@if (showAllTime || showVote) {
  <div class="absolute-divs voting-container {{mediaType}}">
    <div class="vote-group ">
      <p class="info-title">How do you rate this answer?</p>
      <div aria-label="To use this voting slider, press Tab to focus on the vote slider and then use the left and right cursor keys to move the score up and down. Once happy with the score, press enter, then tab to focus on the Finish/Next button."></div>
      <div tabindex="0" id='vote' class="interval-group {{mediaType}}" label="Vote slider" (click)="onVote($event)" (mousemove)="coordinates($event)" (keyup)="keypress($event)" (focus)="onFocus()" (blur)="onBlur()" >
        <div class="selector" id="selector" [ngStyle]="pointerStyle" [attr.aria-label]="votedPreValue"></div>
      </div>
      <div class="info-group">
        <p class="min">Very weak</p>
        <p class="max">Very strong</p>
      </div>
      @if (showInstructions) {
        <div class="instructions">To use this voting slider, press Tab to focus on the vote slider and then use the left and right cursor keys to move the score up and down. Once happy with the score, press enter, then tab to focus on the Finish/Next button.</div>
      }
    </div>
    @if (voted) {
      <div class="submit-vote-group">
        <button id='voteButton' class="btn btn-outline-primary btn-outline hover" (click)="onSubmitVote()">{{ (currentItem == count) ? 'Finish' : 'Next' }}</button>
      </div>
    }
  </div>
}
